import React, {useImperativeHandle, useRef, useState} from 'react'
import WizModal from '../../../../components/modal/WizModal'
import Text from '../../../../components/text/Text'
import WizButton from '../../../../components/button/WizButton'
import UnderLineInput from '../../../../components/input/UnderLineInput'
import Span from '../../../../components/text/Span'
import {deleteLeagueApi} from '../../../../apis/league/deleteLeagueApi'

interface IProps {
    className?: string
}

const DeleteLeagueModal = ({className}: IProps, ref: any) => {
    const [removeText, setRemoveText] = useState('')
    const [leagueId, setLeagueId] = useState('')
    const modalRef = useRef<any>()

    useImperativeHandle(ref, () => ({
        show: id => {
            setLeagueId(id)
            modalRef.current.show()
        },
    }))

    const onClickDelete = async () => {
        if (removeText !== 'REMOVE') {
            alert('이벤트 삭제 키워드가 잘못되었습니다.')
            return false
        }

        const {data, error} = await deleteLeagueApi(leagueId)

        if (data?.success) {
            alert('Remove League Complete')
        } else {
            alert(error)
        }
        modalRef.current.close()
    }

    return (
        <>
            <WizModal title={'Remove League'} className={`${className}`} ref={modalRef}>
                <Text className={'text-body2 text-font02'}>
                    해당 리그를 삭제하시겠습니까? 아래 입력창에 <Span className={'text-ti2 text-font_red'}>REMOVE</Span>
                    를 적어주세요.
                </Text>
                <UnderLineInput className={'mt-[10px]'} onChanged={text => setRemoveText(text)} />
                <div className={'flex space-x-[5px] mt-[30px]'}>
                    <WizButton
                        text={'Cancel'}
                        type={'cancel'}
                        className={'flex-1'}
                        onClick={() => {
                            modalRef.current.close()
                        }}
                    />
                    <WizButton text={'Remove'} type={'red'} className={'flex-1'} onClick={() => onClickDelete()} />
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(DeleteLeagueModal)
